import { render, staticRenderFns } from "./listPages.vue?vue&type=template&id=727db4b9&"
import script from "./listPages.vue?vue&type=script&lang=js&"
export * from "./listPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports